module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1011-9b55a920f9ebde1c341bada6ddef2152.png";